import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  InputLabel,
  Tab,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import CustomTextField from "../CustomComponents/CustomTextField";
import CreditAmountDetails from "./CreditAmountDetails";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import React from "react";
import CustomDateField from "../CustomComponents/CustomDateField";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { FileReceiptGridReducerAction } from "../Store/FileReceiptGridReducer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import dayjs from "dayjs";
import { CheckBoxOutlineBlank, CheckBoxOutlined } from "@mui/icons-material";
import store from "./../Store/index";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const ChequeReceiptDetails = (props) => {
  const [bankAccountNumHasError, setBankAccNumError] = React.useState(false);
  const [accHolderNameHasError, setAccHolderNameError] = React.useState(false);
  const [thirdPartyReceiptHasError, setThirdPartyReceiptError] =
    React.useState(false);
  const [receiptAmtHasError, setReceiptAmtError] = React.useState(false);
  const [totalReceiptAmtHasError, setTotalReceiptAmtError] =
    React.useState(false);

  const [depositBankHasError, setDepositBankError] = React.useState(false);
  const [chequeTypeHasError, setChequeTypeError] = React.useState(false);
  const [chequeModeHasError, setChequeModeError] = React.useState(false);
  const [chequeNumHasError, setChequeNumError] = React.useState(false);
  const [chequeDateHasError, setChequeDateError] = React.useState(false);
  const [narrationHasError, setNarrationError] = React.useState(false);

  const [bankReqDateHasError, setBankReqDateError] = React.useState(false);
  const [bankingDateHasError, setBankingDateError] = React.useState(false);
  const [realizationDateHasError, setRealizationDateError] =
    React.useState(false);
  const [draweerBankHasError, setDraweerBankError] = React.useState(false);
  const [draweerBranchHasError, setDraweerBranchError] = React.useState(false);
  const [chequeTypeArray, setChequeTypeArray] = useState([]);
  const [depositBanksArray, setDepositBanksArray] = useState([]);
  const [depositBanksMap, setDepositBanksMap] = useState([]);
  const [receiptAmtValue, setReceiptAmtValue] = useState(0);
  const [prePaymentReasonValues, setPrePaymentReasonValues] = useState([]);

  const duplicateChequeNumHasError = useSelector(
    (state) => state.fileReceiptGrid.duplicateChequeNumHasError
  );
  const duplicateChequeNumErrorMsg = useSelector(
    (state) => state.fileReceiptGrid.duplicateChequeNumErrorMsg
  );
  const sourceOfFundValues = useSelector(
    (state) => state.fileReceiptGrid.sourceOfFundValues
  );
  const voucherDateValidDateError = useSelector(
    (state) => state.fileReceiptGrid.voucherDateValidDateError
  );
  const [sourceOfFundHasError, setSourceOfFundHasError] = useState(false);
  const [thirdPartyHasError, setThirdPartyHasError] = useState(false);
  const [thirdPartyName, setThirdPartyName] = useState("");

  const [draweerBanksArray, setDraweerBanksArray] = useState([]);
  const [draweerBanksMap, setDraweerBanksMap] = useState([]);

  const [draweerBanksBranchArray, setDraweerBanksBranchArray] = useState([]);
  const [draweerBanksBranchMap, setDraweerBanksBranchMap] = useState([]);

  //Selectors from redux store
  const userName = useSelector((state) => state.branch.userName);

  const prepayReceiptMode = useSelector(
    (state) => state.fileReceiptGrid.prepayReceiptMode
  );

  const prePayDetails = useSelector(
    (state) => state.fileReceiptGrid.prePayDetails
  );

  const saveDone = useSelector((state) => state.fileReceiptGrid.saveDone);

  const currentReceiptCustomerData = useSelector(
    (state) => state.fileReceiptGrid.currentReceiptCustomerData
  );

  const navigate = useNavigate();

  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  //Maintainig State for Dialog while submitting the application
  const [open, setOpen] = useState(false);

  //Importing Hooks
  const dispatch = useDispatch();

  const [glAccountDataMap, setGlAccountDataMap] = useState({});
  const dateEnableDetails = useSelector(
    (state) => state.fileReceiptGrid.dateEnableDetails
  );

  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const nextRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "chequeReceipt",
        })
      );
    }
  };
  useEffect(() => {
    getPrePaymentReason();
  }, []);
  const getPrePaymentReason = async () => {
    try {
      const response = await axios.post(
        "/prepaymentCharges/getPrePaymentReason",
        { apiCode: "PRE_PAYMENT_REASONS_API", createdBy: userName }
      );
      if (response.data) {
        setPrePaymentReasonValues(response.data);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const chequeDateValidation = (value) => {
    new Date(value).toDateString() !== "Invalid Date" &&
    value !== null &&
    new Date(value).toLocaleDateString().slice(-4) >=
      String(
        new Date(
          new Date(props.fileReceiptState.voucherDate).setDate(
            new Date(props.fileReceiptState.voucherDate).getDate() - 90
          )
        ).getFullYear()
      ) &&
    new Date(value) >=
      new Date(
        dayjs(
          new Date(
            new Date(props.fileReceiptState.voucherDate).setDate(
              new Date(props.fileReceiptState.voucherDate).getDate() - 90
            )
          )
        ).format("MM/DD/YYYY")
      ) &&
    new Date(value).toLocaleDateString().slice(-4) <=
      String(new Date(props.fileReceiptState.voucherDate).getFullYear()) &&
    new Date(value) <=
      new Date(dayjs(props.fileReceiptState.voucherDate).format("MM/DD/YYYY"))
      ? setChequeDateError(false)
      : setChequeDateError(true);
  };

  const bankReqDateValidation = (value) => {
    new Date(value).toDateString() !== "Invalid Date" &&
    value !== null &&
    new Date(value).toLocaleDateString().slice(-4) >=
      String(new Date(props.fileReceiptState.voucherDate).getFullYear()) &&
    new Date(value) >=
      new Date(
        dayjs(props.fileReceiptState.voucherDate).format("MM/DD/YYYY")
      ) &&
    new Date(value).toLocaleDateString().slice(-4) <=
      String(
        new Date(
          new Date(props.fileReceiptState.voucherDate).setDate(
            new Date(props.fileReceiptState.voucherDate).getDate() + 30
          )
        ).getFullYear()
      ) &&
    new Date(value) <=
      new Date(
        dayjs(
          new Date(
            new Date(props.fileReceiptState.voucherDate).setDate(
              new Date(props.fileReceiptState.voucherDate).getDate() + 30
            )
          )
        ).format("MM/DD/YYYY")
      )
      ? setBankReqDateError(false)
      : setBankReqDateError(true);
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let flag =
      new Date().toLocaleDateString() <
      new Date(props.fileReceiptState.voucherDate).toLocaleDateString();
    let date = new Date();
    let refList = { cancelRef: cancelRef };
    if (event.ctrlKey) {
      if (charCode === "q") {
        cancelRef.current.click();
      } else if (charCode === "y") {
        yesRef.current.click();
      } else if (charCode === "g") {
        nextRef.current.click();
      }
    }
  };

  useEffect(() => {
    const glAccountData = { ...props.glAccountDataMap };
    if (prepayReceiptMode) {
      let newObject = {};
      Object.entries(glAccountData).forEach((entry) => {
        const keyValue = entry[0];
        const dataValue = entry[1];
        newObject[keyValue] = [...dataValue];
      });
      setGlAccountDataMap(newObject);
    } else {
      let newObject = {};
      Object.entries(glAccountData).forEach((entry) => {
        const keyValue = entry[0];
        const dataValue = entry[1];
        newObject[keyValue] = [...dataValue]
          .filter(
            (record) =>
              !String(record.account_desc).includes("PREPAYMENT") &&
              !String(record.account_desc).includes("PRE-PAYMENT") &&
              !String(record.account_desc).includes("PREPAY")
          )
          .filter((glrecord) =>
            Object.keys(currentReceiptCustomerData).length > 0
              ? currentReceiptCustomerData?.losStatus === "Sanctioned" ||
                currentReceiptCustomerData?.losStatus === "Requested"
                ? !String(glrecord.account_desc).startsWith("EMI")
                : true
              : true
          );
      });
      setGlAccountDataMap(newObject);
    }
  }, [prepayReceiptMode]);

  useEffect(() => {
    const getChequeTypes = async () => {
      const chequeTypesResponse = await axios.post(
        "/filereceipt/getChequeTypes",
        {
          apiCode: "CHEQUE_TYPE_LOV_API",
          createdBy: userName,
          lastModifiedBy: userName,
        }
      );
      if (Object.keys(chequeTypesResponse.data).length > 0) {
        const types =
          Number(chequeTypesResponse.data.status) === 1
            ? chequeTypesResponse.data.cheque_type
            : [];
        const chequetypes = types.map((type) => type.cheque_categorey_desc);
        setChequeTypeArray([...chequetypes]);
      }
    };
    const getDepositBank = async () => {
      try {
        const branchCodeValue = props.branchNamesWithCodes.find((branch) => {
          return branch.label === props.fileReceiptState.branch;
        });
        const response = await axios.post("/filepayment/getPaymentBank", {
          apiCode: "BANK_CASH_ACCOUNT_API",
          createdBy: userName,
          lastModifiedBy: userName,
          branchCodes: branchCodeValue.code,
        });
        if (Object.keys(response.data).length > 0) {
          if (Number(response.data.status) === 1) {
            const depositBanks = response.data.ledger_details;
            const bankNames = depositBanks.map((rec) => rec.branch_name);
            setDepositBanksArray(bankNames);
            setDepositBanksMap(depositBanks);
          } else {
            setDepositBanksArray([]);
            setDepositBanksMap([]);
          }
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    };
    const getDraweerBanks = async () => {
      try {
        const response = await axios.post("/filereceipt/getDraweerBanks", {
          apiCode: "BANK_LIST_SHFL_API",
          createdBy: userName,
          lastModifiedBy: userName,
        });
        if (Object.keys(response.data).length > 0) {
          if (Number(response.data.status) === 1) {
            const bankLists = response.data.bank_list;
            const bankNames = bankLists.map((rec) => rec.bank_name);
            setDraweerBanksArray(bankNames);
            setDraweerBanksMap(bankLists);
          } else {
            setDraweerBanksArray([]);
            setDraweerBanksMap([]);
          }
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    };
    getDepositBank();
    getDraweerBanks();
    getChequeTypes();
    dispatch(FileReceiptGridReducerAction.updateInitialLoad(true));
    return () => {
      dispatch(
        FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter(
          {}
        )
      );
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOk = () => {
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    // since this method called on prepay mode toggle on above we reset the grid data since gl account data changes.
    dispatch(FileReceiptGridReducerAction.updateInitialLoad(true));
    let currentStateValue = { ...props.fileReceiptState };
    currentStateValue.prepayReceiptMode =
      store.getState().fileReceiptGrid.prepayReceiptMode;
    let prepayDetailsData = store.getState().fileReceiptGrid.prePayDetails;
    currentStateValue = { ...currentStateValue, ...prepayDetailsData };
    dispatch(
      FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter(
        currentStateValue
      )
    );
    if (prepayReceiptMode) {
      // remove of prepay mode.
      dispatch(FileReceiptGridReducerAction.resetPrepayDetails());
      dispatch(
        FileReceiptGridReducerAction.updatePrePayReceiptMode(!prepayReceiptMode)
      );
      // on remove of prepay make prepay effective date as null.
      dispatch(FileReceiptGridReducerAction.updatePrepayEffectiveDate(null));
    } else {
      dispatch(
        FileReceiptGridReducerAction.updatePrePayReceiptMode(!prepayReceiptMode)
      );
      // new spec for effective date -> it should be same as voucher Date.
      dispatch(
        FileReceiptGridReducerAction.updatePrepayEffectiveDate(
          props.fileReceiptState.voucherDate
        )
      );
    }
    setOpen(false);
  };

  const openAlertDialog = () => {
    if (!saveDone) {
      setDialogMessage(
        prepayReceiptMode
          ? "Receipt Process Not Completed. Do you want to leave from PrePay Receipt Mode and continue ?"
          : "Receipt Process Not Completed. Do you want to enter  PrePay Receipt Mode and continue ?"
      );
      setDialogTitleMessage("Confirmation");
      setOpen(true);
    }
  };

  const onProceedClick = async () => {
    // validate the required fields based on mode & change the tab.
    let errorExist = false;
    if (props.screenMode === "CREATE" || props.screenMode === "MODIFY") {
      const filterReceiptStateValue = { ...props.fileReceiptState };
      if (
        filterReceiptStateValue.bankAccountNum === "" ||
        filterReceiptStateValue.bankAccountNum === null ||
        filterReceiptStateValue.bankAccountNum === undefined ||
        filterReceiptStateValue.bankAccountNum.length > 18 ||
        filterReceiptStateValue.bankAccountNum.length < 9
      ) {
        errorExist = true;
        setBankAccNumError(true);
      }
      if (
        filterReceiptStateValue.accHolderName === "" ||
        filterReceiptStateValue.accHolderName === null ||
        filterReceiptStateValue.accHolderName === undefined ||
        filterReceiptStateValue.accHolderName.length > 100
      ) {
        errorExist = true;
        setAccHolderNameError(true);
      }
      // if (
      //   filterReceiptStateValue.reasonForReceipt === "" ||
      //   filterReceiptStateValue.reasonForReceipt === undefined ||
      //   filterReceiptStateValue.reasonForReceipt === null
      // ) {
      //   errorExist = true;
      //   setThirdPartyReceiptError(true);
      // }
      if (
        filterReceiptStateValue.receiptAmt === "" ||
        filterReceiptStateValue.receiptAmt === 0 ||
        filterReceiptStateValue.receiptAmt === "0"
      ) {
        errorExist = true;
        setReceiptAmtError(true);
      }
      // if (
      //   filterReceiptStateValue.totalReceiptAmt === "" ||
      //   filterReceiptStateValue.totalReceiptAmt === 0 ||
      //   filterReceiptStateValue.totalReceiptAmt === "0"
      // ) {
      //   errorExist = true;
      //   setTotalReceiptAmtError(true);
      // }

      if (
        filterReceiptStateValue.depositBank === "" ||
        filterReceiptStateValue.depositBank === undefined ||
        filterReceiptStateValue.depositBank === null
      ) {
        errorExist = true;
        setDepositBankError(true);
      }
      if (
        filterReceiptStateValue.chequeType === "" ||
        filterReceiptStateValue.chequeType === undefined ||
        filterReceiptStateValue.chequeType === null
      ) {
        errorExist = true;
        setChequeTypeError(true);
      }
      // if (
      //   filterReceiptStateValue.chequeMode === "" ||
      //   filterReceiptStateValue.chequeMode === undefined ||
      //   filterReceiptStateValue.chequeMode === null
      // ) {
      //   errorExist = true;
      //   setChequeModeError(true);
      // }
      if (
        filterReceiptStateValue.chequeNum === "" ||
        filterReceiptStateValue.chequeNum === undefined ||
        filterReceiptStateValue.chequeNum === null ||
        filterReceiptStateValue.chequeNum.length < 6 ||
        filterReceiptStateValue.chequeNum.length > 6
      ) {
        errorExist = true;
        setChequeNumError(true);
        dispatch(
          FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(false)
        );
      }

      // validate for the cheque Number on next btn click also.
      // trigger backend validation only for the cheque create mode.
      if (
        props.screenMode === "CREATE" &&
        filterReceiptStateValue.receiptFor === "Application Number"
      ) {
        dispatch(
          FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(false)
        );
        dispatch(
          FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg("")
        );
        if (
          String(filterReceiptStateValue.chequeNum).length <= 6 &&
          filterReceiptStateValue.chequeNum !== "" &&
          filterReceiptStateValue.chequeNum !== null &&
          filterReceiptStateValue.chequeNum !== undefined
        ) {
          const value = filterReceiptStateValue.chequeNum;
          const response = await axios.post(
            "/filereceipt/chequeNumberDuplicateCheck",
            {
              chequeNum: value,
              applicationList: [filterReceiptStateValue.applicationNum],
            }
          );
          if (response.status === 206) {
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                true
              )
            );
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                response.data
              )
            );
            errorExist = true;
          } else {
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                false
              )
            );
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg("")
            );
          }
        }
      }

      if (
        props.screenMode === "CREATE" &&
        (filterReceiptStateValue.chequeDate === "" ||
          filterReceiptStateValue.chequeDate === undefined ||
          filterReceiptStateValue.chequeDate === null ||
          new Date(filterReceiptStateValue.chequeDate).toDateString() ===
            "Invalid Date" ||
          new Date(filterReceiptStateValue.chequeDate) <
            new Date(new Date().setDate(new Date().getDate() - 90)) ||
          new Date(filterReceiptStateValue.chequeDate) >
            new Date(filterReceiptStateValue.voucherDate))
      ) {
        errorExist = true;
        setChequeDateError(true);
      }
      if (
        filterReceiptStateValue.bankReqDate === "" ||
        filterReceiptStateValue.bankReqDate === undefined ||
        filterReceiptStateValue.bankReqDate === null ||
        new Date(filterReceiptStateValue.chequeDate).toDateString() ===
          "Invalid Date" ||
        new Date(props.fileReceiptState.bankReqDate) <
          new Date(props.fileReceiptState.voucherDate) ||
        new Date(props.fileReceiptState.bankReqDate) >
          new Date(new Date(new Date().setDate(new Date().getDate() + 30)))
      ) {
        errorExist = true;
        setBankReqDateError(true);
      }
      if (
        filterReceiptStateValue.drawerBank === "" ||
        filterReceiptStateValue.drawerBank === undefined ||
        filterReceiptStateValue.drawerBank === null
      ) {
        errorExist = true;
        setDraweerBankError(true);
      }

      if (
        filterReceiptStateValue.drawerBranch === "" ||
        filterReceiptStateValue.drawerBranch === undefined ||
        filterReceiptStateValue.drawerBranch === null
      ) {
        errorExist = true;
        setDraweerBranchError(true);
      }
      if (
        filterReceiptStateValue.narration === null ||
        filterReceiptStateValue.narration === undefined ||
        filterReceiptStateValue.narration === "" ||
        filterReceiptStateValue.narration.length === 0 ||
        String(filterReceiptStateValue.narration).length > 2000
      ) {
        errorExist = true;
        setNarrationError(true);
      }

      if (
        (props.fileReceiptState.sourceOfFund === "Third Party" &&
          props.fileReceiptState.thirdPartyName &&
          props.fileReceiptState.thirdPartyName !== "" &&
          props.fileReceiptState.thirdPartyName.length > 255) ||
        (props.fileReceiptState.sourceOfFund === "Third Party" &&
          (props.fileReceiptState.thirdPartyName === null ||
            props.fileReceiptState.thirdPartyName === undefined ||
            props.fileReceiptState.thirdPartyName === "" ||
            !/^[A-Za-z\s]*$/.test(props.fileReceiptState.thirdPartyName)))
      ) {
        errorExist = true;
        setThirdPartyHasError(true);
      } else {
        setThirdPartyHasError(false);
      }
      if (
        props.fileReceiptState.sourceOfFund === "" ||
        props.fileReceiptState.sourceOfFund === null ||
        props.fileReceiptState.sourceOfFund === undefined
      ) {
        errorExist = true;
        setSourceOfFundHasError(true);
      } else {
        setSourceOfFundHasError(false);
      }

      // for modify mode Cheque For realization Date & Banking Date Validation.
      if (props.screenMode === "MODIFY") {
        if (
          filterReceiptStateValue.bankingDate === "" ||
          filterReceiptStateValue.bankingDate === undefined ||
          filterReceiptStateValue.bankingDate === null ||
          new Date(filterReceiptStateValue.bankingDate).toDateString() ===
            "Invalid Date" ||
          new Date(props.fileReceiptState.bankingDate) <
            new Date(props.fileReceiptState.bankReqDate) ||
          new Date(props.fileReceiptState.bankingDate) >
            new Date(new Date("12/31/2055"))
        ) {
          errorExist = true;
          setBankingDateError(true);
        }

        if (
          filterReceiptStateValue.realizationDate === "" ||
          filterReceiptStateValue.realizationDate === undefined ||
          filterReceiptStateValue.realizationDate === null ||
          new Date(filterReceiptStateValue.realizationDate).toDateString() ===
            "Invalid Date" ||
          new Date(props.fileReceiptState.realizationDate) <
            new Date(props.fileReceiptState.bankReqDate) ||
          new Date(props.fileReceiptState.realizationDate) >
            new Date(new Date("12/31/2055"))
        ) {
          errorExist = true;
          setRealizationDateError(true);
        }
      }

      if (prepayReceiptMode) {
        if (
          prePayDetails.prepayReason === "" ||
          prePayDetails.prepayReason === null ||
          prePayDetails.prepayReason === undefined
        ) {
          errorExist = true;
          dispatch(
            FileReceiptGridReducerAction.updatePrepayReasonTouched(true)
          );
        } else {
          dispatch(
            FileReceiptGridReducerAction.updatePrepayReasonTouched(false)
          );
        }

        if (prePayDetails.prepayReason === "Pre-Take over") {
          if (
            prePayDetails.bankAndInstructions === "" ||
            prePayDetails.bankAndInstructions === null ||
            prePayDetails.bankAndInstructions === undefined
          ) {
            errorExist = true;
            dispatch(
              FileReceiptGridReducerAction.updateBankAndInstructionsTouched(
                true
              )
            );
          } else {
            dispatch(
              FileReceiptGridReducerAction.updateBankAndInstructionsTouched(
                false
              )
            );
          }

          if (
            prePayDetails.takeOverReason === "" ||
            prePayDetails.takeOverReason === null ||
            prePayDetails.takeOverReason === undefined
          ) {
            errorExist = true;
            dispatch(
              FileReceiptGridReducerAction.updateTakeOverReasonTouched(true)
            );
          } else {
            dispatch(
              FileReceiptGridReducerAction.updateTakeOverReasonTouched(false)
            );
          }
        }

        // if (
        //   prePayDetails.effectiveDate === "" ||
        //   prePayDetails.effectiveDate === undefined ||
        //   prePayDetails.effectiveDate === null ||
        //   new Date(prePayDetails.effectiveDate).toDateString() ===
        //     "Invalid Date" ||
        //   new Date(prePayDetails.effectiveDate) <
        //     new Date(dayjs(new Date()).format("MM/DD/YYYY")) ||
        //   new Date(prePayDetails.effectiveDate) >
        //     new Date(dayjs(new Date()).format("MM/DD/YYYY"))
        // ) {
        //   errorExist = true;
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateHasError(true)
        //   );
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateIsValid(false)
        //   );
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateTouch(true)
        //   );
        // } else {
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateHasError(
        //       false
        //     )
        //   );
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateIsValid(true)
        //   );
        //   dispatch(
        //     FileReceiptGridReducerAction.updatePrepayEffectiveDateTouch(false)
        //   );
        // }

        if (
          prePayDetails.prepayNarration === null ||
          prePayDetails.prepayNarration === undefined ||
          prePayDetails.prepayNarration === "" ||
          prePayDetails.prepayNarration.length === 0 ||
          String(prePayDetails.prepayNarration).length > 2000
        ) {
          errorExist = true;
          dispatch(
            FileReceiptGridReducerAction.updatePrepayNarrationTouched(true)
          );
        } else {
          dispatch(
            FileReceiptGridReducerAction.updatePrepayNarrationTouched(false)
          );
        }
      }

      // validate the cheque num is present from backend only for Create mode.
      if (props.screenMode === "CREATE" && duplicateChequeNumHasError) {
        errorExist = true;
      }
    }
    if (!errorExist) {
      // no error move to other tab.
      props.handleTabChange("2");
    }
  };

  const onChangeDraweerBank = (bankName) => {
    if (bankName !== null && bankName !== "" && bankName !== undefined) {
      props.dispatch({
        type: props.fileReceiptScreenFields.drawerBranch,
        value: null,
      });
      const bankData = draweerBanksMap.filter(
        (rec) => rec.bank_name === bankName
      );
      const bankCode = bankData[0].bank_code;
      const getDraweerBanksBranch = async () => {
        try {
          const response = await axios.post(
            "/filereceipt/getDraweerBanksBranch",
            {
              shflApisModel: {
                apiCode: "BANK_BRANCH_LIST_SHFL_API",
                createdBy: userName,
                lastModifiedBy: userName,
              },
              bankCode: bankCode,
            }
          );
          if (Object.keys(response.data).length > 0) {
            if (Number(response.data.status) === 1) {
              const branchLists = response.data.branch_list;
              const branchNames = branchLists.map((rec) => rec.branch_name);
              setDraweerBanksBranchArray(branchNames);
              setDraweerBanksBranchMap(branchLists);
            } else {
              setDraweerBanksBranchArray([]);
              setDraweerBanksBranchMap([]);
            }
          }
        } catch (error) {
          console.log(error);
          throw Error(error);
        }
      };
      getDraweerBanksBranch();
      props.dispatch({
        type: props.fileReceiptScreenFields.drawerBank,
        value: bankName,
      });
    } else {
      setDraweerBanksBranchArray([]);
      setDraweerBanksBranchMap([]);
      props.dispatch({
        type: props.fileReceiptScreenFields.drawerBank,
        value: null,
      });
      props.dispatch({
        type: props.fileReceiptScreenFields.drawerBranch,
        value: null,
      });
    }
  };

  const removeUnwantedChars = (inputValue, typeValue) => {
    const regExpString =
      /^(?=\n)$|^\s*|^\s*$(?:\r\n?|\n)|\n\n+|\t|[^a-zA-Z0-9.,]|[%<>\\$'"{}\[\]]/gim;
    let formattedValue = String(inputValue).replace(regExpString, " ");
    // we need to remove twice since relaced space shouldbe removed
    formattedValue = String(formattedValue).replace(/[^\u0000-\u007F]+/, "");
    let finalValue = String(formattedValue).replace(regExpString, " ");
    finalValue = finalValue.replace(/\s+/g, " ");
    finalValue = finalValue.trimStart();
    // remove the starting space, comma, dot at starting position of string only.
    if (finalValue.startsWith(",") || finalValue.startsWith(".")) {
      finalValue = finalValue.replace(/,+/g, ",");
      finalValue = finalValue.replace(/,/, "");
      finalValue = finalValue.replace(/\.+/g, ".");
      finalValue = finalValue.replace(/\./, "");
    }

    if (typeValue === props.fileReceiptScreenFields.narration) {
      setNarrationError(
        finalValue !== null &&
          finalValue !== undefined &&
          finalValue !== "" &&
          finalValue.length > 0 &&
          String(finalValue).length < 2000
          ? false
          : true
      );
    }

    if (typeValue === props.fileReceiptScreenFields.bankAccountNum) {
      setBankAccNumError(
        finalValue && finalValue !== "" && String(finalValue).length <= 18
          ? false
          : true
      );
    }
    if (typeValue === "prepayNarration") {
      dispatch(FileReceiptGridReducerAction.updatePrepayNarration(finalValue));
      dispatch(FileReceiptGridReducerAction.updatePrepayNarrationTouched(true));
    }

    if (typeValue !== "prepayNarration") {
      props.dispatch({
        type: typeValue,
        value: finalValue,
      });
    }
  };

  const handleTabChange = (newValue) => {
    props.handleTabChange(newValue);
  };

  const receiptDetailsContent = (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "white",
        marginBottom: "16px",
        marginTop: "-2%",
      }}
    >
      <Box component="form">
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={props.screenMode === "VIEW"}
              required={props.screenMode !== "VIEW"}
              label="Source of Fund"
              variant="standard"
              type="text"
              placeholder={
                props.screenMode === "CREATE"
                  ? "Select Source of Fund"
                  : "Source of Fund"
              }
              autoCompleteValues={sourceOfFundValues}
              value={props.fileReceiptState.sourceOfFund}
              onChange={(event, value) => {
                setSourceOfFundHasError(
                  value !== null && value !== "" && value !== undefined
                    ? false
                    : true
                );
                props.dispatch({
                  type: props.fileReceiptScreenFields.sourceOfFund,
                  value: value,
                });
                if (value === "Third Party") {
                  dispatch(
                    FileReceiptGridReducerAction.updateThirdPartDisplayFlag(
                      true
                    )
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateThirdPartyNameDisableModeFlag(
                      false
                    )
                  );
                } else {
                  dispatch(
                    FileReceiptGridReducerAction.updateThirdPartDisplayFlag(
                      false
                    )
                  );
                }
              }}
            />
            {sourceOfFundHasError && props.screenMode === "CREATE" && (
              <p className="error">Please Select Source Of Fund</p>
            )}
          </Grid>
          {props.fileReceiptState.sourceOfFund === "Third Party" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                disabled={props.screenMode === "VIEW"}
                required={props.screenMode !== "VIEW"}
                label="Third Party Name"
                id="thirdParty"
                variant="standard"
                value={props.fileReceiptState.thirdPartyName}
                tooltip={props.fileReceiptState.thirdPartyName}
                type="text"
                placeholder="Enter Third Party Name"
                onChange={(event) => {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.thirdPartyName,
                    value: event.target.value,
                  });
                  const newValue = event.target.value;
                  setThirdPartyName(newValue);
                  setThirdPartyHasError(
                    newValue !== null &&
                      newValue !== "" &&
                      newValue !== undefined &&
                      /^[A-Za-z\s]*$/.test(newValue)
                      ? false
                      : true
                  );
                  if (newValue.length > 255) {
                    setThirdPartyHasError(true);
                  }
                }}
              />
              {thirdPartyHasError && props.screenMode === "CREATE" && (
                <p className="error">
                  {!thirdPartyName ||
                  thirdPartyName === "" ||
                  !/^[A-Za-z\s]*$/.test(thirdPartyName)
                    ? "Please Enter Valid Third Party Name"
                    : thirdPartyName.length > 255
                    ? "Please Enter Third Party Name less than 255 Characters"
                    : ""}
                </p>
              )}
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={
                props.fileReceiptState.receiptFor === "Customer ID"
                  ? props.screenMode === "VIEW"
                  : true
              }
              required={false}
              label="Bank Account Number"
              id="bankAccountNum"
              variant="standard"
              value={props.fileReceiptState.bankAccountNum}
              type="number"
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: { textAlign: `left`, fontSize: "12px" },
              }}
              placeholder="Enter Bank Account Number"
              onChange={(event) => {
                if (event.target.value.length <= 18) {
                  removeUnwantedChars(
                    event.target.value,
                    props.fileReceiptScreenFields.bankAccountNum
                  );
                } else {
                  return;
                }
              }}
            />
            {bankAccountNumHasError && (
              <p className="error">Please Enter Valid Bank Account Number</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={
                props.fileReceiptState.receiptFor === "Customer ID"
                  ? props.screenMode === "VIEW"
                  : true
              }
              required={false}
              label="Account Holder Name"
              id="accHolderName"
              variant="standard"
              value={props.fileReceiptState.accHolderName}
              type="text"
              placeholder="Enter Account Holder Name"
              onChange={(event) => {
                const value = event.target.value;
                setAccHolderNameError(value && value !== "" ? false : true);
                if (event.target.value.length <= 100) {
                  removeUnwantedChars(
                    value,
                    props.fileReceiptScreenFields.accHolderName
                  );
                } else {
                  return;
                }
              }}
            />
            {accHolderNameHasError && (
              <p className="error">
                {props.fileReceiptState.accHolderName === null ||
                props.fileReceiptState.accHolderName === undefined ||
                props.fileReceiptState.accHolderName === ""
                  ? "Please Enter Account Holder Name"
                  : props.fileReceiptState.accHolderName.length > 100
                  ? `Please Enter Account Holder Name Can't be Greater than 100 Characters`
                  : ""}
              </p>
            )}
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Reason for 3rd Party Receipt"
              id="reasonForReceipt"
              variant="standard"
              value={props.fileReceiptState.reasonForReceipt}
              type="text"
              placeholder="Enter Reason for 3rd Party Receipt"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.reasonForReceipt,
                  value: event.target.value,
                });
                const value = event.target.value;
                setThirdPartyReceiptError(value && value !== "" ? false : true);
              }}
            />
            {thirdPartyReceiptHasError && (
              <p className="error">Please Enter Reason for Receipt</p>
            )}
          </Grid> */}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={props.screenMode === "VIEW"}
              required={props.screenMode !== "VIEW"}
              label="Receipt Amount"
              id="receiptAmt"
              variant="standard"
              value={
                props.fileReceiptState.receiptAmt === ""
                  ? 0
                  : parseInt(props.fileReceiptState.receiptAmt).toLocaleString(
                      "en-IN"
                    )
              }
              type="text"
              placeholder="Receipt Amount"
              onChange={(event) => {
                if (
                  !Number.isNaN(Number(event.target.value.replaceAll(",", "")))
                ) {
                  const newValue =
                    Number(event.target.value.replaceAll(",", "")) <= 0
                      ? 0
                      : Number(event.target.value.replaceAll(",", "")) <
                        999999999
                      ? event.target.value.replaceAll(",", "")
                      : 999999999;
                  if (Math.floor(Number(newValue)) < 999999999) {
                    props.dispatch({
                      type: props.fileReceiptScreenFields.receiptAmt,
                      value: Math.floor(newValue),
                    });
                  } else {
                    props.dispatch({
                      type: props.fileReceiptScreenFields.receiptAmt,
                      value: Math.floor(999999999),
                    });
                  }

                  setReceiptAmtValue(Math.floor(newValue));
                  setReceiptAmtError(
                    Math.floor(newValue) <= 0 ||
                      Math.floor(newValue) > 999999999
                      ? true
                      : false
                  );
                  setTotalReceiptAmtError(newValue <= 0 ? true : false);
                } else {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.receiptAmt,
                    value: 0,
                  });
                  setReceiptAmtError(true);
                  setTotalReceiptAmtError(true);
                }
              }}
            />
            {receiptAmtHasError && (
              <p className="error">
                {Number.isNaN(Number(receiptAmtValue)) ||
                Number(receiptAmtValue) <= 0
                  ? "Please Enter Receipt Amount"
                  : Number(receiptAmtValue) > 999999999
                  ? "Please Enter Receipt Amount less than 99,99,99,999"
                  : ""}
              </p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Total Receipt Amount"
              id="totalReceiptAmt"
              variant="standard"
              value={
                props.fileReceiptState.totalReceiptAmt === ""
                  ? 0
                  : parseInt(
                      props.fileReceiptState.totalReceiptAmt
                    ).toLocaleString("en-IN")
              }
              type="text"
              placeholder="Total Receipt Amount"
              onChange={(event) => {
                if (
                  !Number.isNaN(Number(event.target.value.replaceAll(",", "")))
                ) {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.totalReceiptAmt,
                    value: event.target.value.replaceAll(",", ""),
                  });
                  dispatch(
                    FileReceiptGridReducerAction.updateRemainingCreditAmt(
                      Number(event.target.value.replaceAll(",", ""))
                    )
                  );
                  setTotalReceiptAmtError(false);
                } else {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.totalReceiptAmt,
                    value: 0,
                  });
                  dispatch(
                    FileReceiptGridReducerAction.updateRemainingCreditAmt(
                      Number(0)
                    )
                  );
                  setTotalReceiptAmtError(false);
                }
              }}
            />
            {/* {totalReceiptAmtHasError && (
              <p className="error">Please Enter Total Receipt Amount</p>
            )} */}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Deposit Bank"
              id="depositBank"
              variant="standard"
              autoCompleteValues={depositBanksArray}
              value={props.fileReceiptState.depositBank}
              tooltip={props.fileReceiptState.depositBank}
              type="text"
              placeholder="Select Deposit Bank"
              onChange={(event, value) => {
                if (value && value !== "") {
                  const banks = depositBanksMap.filter(
                    (rec) => rec.branch_name === value
                  );
                  const bankCode = banks[0].gl_account;
                  const bankBranchKey = banks[0].bank_branch_key;
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBank,
                    value: value,
                  });
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBankCode,
                    value: bankCode,
                  });
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBankBranchKey,
                    value: bankBranchKey,
                  });
                } else {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBank,
                    value: value,
                  });
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBankCode,
                    value: "",
                  });
                  props.dispatch({
                    type: props.fileReceiptScreenFields.depositBankBranchKey,
                    value: "",
                  });
                }
                setDepositBankError(value && value !== "" ? false : true);
              }}
            />
            {depositBankHasError && (
              <p className="error">Please Select Deposit Bank</p>
            )}
          </Grid>

          {(Object.keys(currentReceiptCustomerData).length > 0
            ? currentReceiptCustomerData?.losStatus !== "Sanctioned" &&
              currentReceiptCustomerData?.losStatus !== "Requested"
            : true) && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <FormControlLabel
                label="Are You Processing PrePay Receipt"
                labelPlacement="start"
                disableTypography={true}
                sx={{
                  marginTop: "24px !important",
                  color: "#004A92 !important",
                  fontWeight: "400 !important",
                  fontSize: "14px !important",
                }}
                control={
                  <Checkbox
                    checked={prepayReceiptMode}
                    disabled={
                      props.screenMode === "VIEW" ||
                      (Object.keys(currentReceiptCustomerData).length > 0
                        ? currentReceiptCustomerData?.losStatus ===
                            "Sanctioned" ||
                          currentReceiptCustomerData?.losStatus === "Requested"
                        : false)
                    }
                    onChange={(event) => {
                      // openAlertDialog();
                      handleOk();
                    }}
                    icon={<CheckBoxOutlineBlank />}
                    checkedIcon={<CheckBoxOutlined />}
                  />
                }
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );

  const chequeDetailsContent = (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "white",
        marginBottom: "16px",
        marginTop: "-0.5%",
      }}
    >
      <Box component="form">
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Cheque Type"
              id="chequeType"
              variant="standard"
              type="text"
              placeholder="Select Cheque Type"
              autoCompleteValues={chequeTypeArray}
              value={props.fileReceiptState.chequeType}
              onChange={(event, value) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.chequeType,
                  value: value,
                });
                setChequeTypeError(value && value !== "" ? false : true);
                // setChequeModeError(value && value !== "" ? false : true);
                // if (value) {
                //   props.dispatch({
                //     type: props.fileReceiptScreenFields.chequeMode,
                //     value: "CTS",
                //   });
                // } else {
                //   props.dispatch({
                //     type: props.fileReceiptScreenFields.chequeMode,
                //     value: "",
                //   });
                // }
              }}
            />
            {chequeTypeHasError && (
              <p className="error">Please Select Cheque Type</p>
            )}
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}> */}
          {/* <CustomTextField
              disabled={true}
              required={false}
              label="Cheque Mode"
              id="chequeMode"
              variant="standard"
              value={props.fileReceiptState.chequeMode}
              type="text"
              placeholder="Cheque Mode"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.chequeMode,
                  value: event.target.value,
                });
                const value = event.target.value;
                setChequeModeError(value && value !== "" ? false : true);
              }}
            /> */}
          {/* {chequeModeHasError && (
              <p className="error">Please Enter Cheque Mode</p>
            )} */}
          {/* </Grid> */}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Cheque Number"
              id="chequeNum"
              variant="standard"
              value={props.fileReceiptState.chequeNum}
              type="number"
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: { textAlign: `left`, fontSize: "12px" },
              }}
              placeholder="Enter Cheque Number"
              onBlur={async (event) => {
                dispatch(
                  FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                    false
                  )
                );
                dispatch(
                  FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                    ""
                  )
                );
                if (
                  props.fileReceiptState.receiptFor === "Application Number"
                ) {
                  // trigger backend validation only for the cheque create mode.
                  if (props.screenMode === "CREATE") {
                    const value = String(event.target.value);
                    if (
                      value.length <= 6 &&
                      value !== "" &&
                      value !== null &&
                      value !== undefined
                    ) {
                      const response = await axios.post(
                        "/filereceipt/chequeNumberDuplicateCheck",
                        {
                          chequeNum: value,
                          applicationList: [
                            props.fileReceiptState.applicationNum,
                          ],
                        }
                      );
                      if (response.status === 206) {
                        dispatch(
                          FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                            true
                          )
                        );
                        dispatch(
                          FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                            response.data
                          )
                        );
                      } else {
                        dispatch(
                          FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                            false
                          )
                        );
                        dispatch(
                          FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                            ""
                          )
                        );
                      }
                    } else {
                      return;
                    }
                  }
                }
              }}
              onChange={(event) => {
                dispatch(
                  FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                    false
                  )
                );
                dispatch(
                  FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                    ""
                  )
                );
                if (event.target.value.length <= 6) {
                  const value = event.target.value;
                  props.dispatch({
                    type: props.fileReceiptScreenFields.chequeNum,
                    value: String(
                      value < 0 ? "" : String(value).includes(".") ? "" : value
                    ),
                  });

                  setChequeNumError(value && value !== "" ? false : true);
                } else {
                  return;
                }
              }}
            />
            {chequeNumHasError && (
              <p className="error">
                {props.fileReceiptState.chequeNum === null ||
                props.fileReceiptState.chequeNum === undefined ||
                props.fileReceiptState.chequeNum === ""
                  ? "Please Enter Cheque Number"
                  : props.fileReceiptState.chequeNum.length > 6 ||
                    props.fileReceiptState.chequeNum.length < 6
                  ? "Please Enter Valid Cheque Number"
                  : ""}
              </p>
            )}
            {duplicateChequeNumHasError && (
              <p className="error">{duplicateChequeNumErrorMsg}</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Cheque Date"
              id="chequeDate"
              variant="standard"
              minDate={
                new Date(
                  new Date(props.fileReceiptState.voucherDate).setDate(
                    new Date(props.fileReceiptState.voucherDate).getDate() - 90
                  )
                )
              }
              onOpen={() => {
                let dateMap = {
                  chequeDateEnable: true,
                  bankDateEnable: false,
                  voucherDateEnable: false,
                  bankingDateEnable: false,
                  realizationDateEnable: false,
                };
                dispatch(
                  FileReceiptGridReducerAction.updateDateEnableDetails(dateMap)
                );
              }}
              maxDate={props.fileReceiptState.voucherDate}
              value={props.fileReceiptState.chequeDate}
              type="text"
              placeholder="Select Cheque Date"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.chequeDate,
                  value: event,
                });
                const value = event;
                new Date(value).toDateString() !== "Invalid Date" &&
                value !== null &&
                new Date(value).toLocaleDateString().slice(-4) >=
                  String(
                    new Date(
                      new Date(props.fileReceiptState.voucherDate).setDate(
                        new Date(props.fileReceiptState.voucherDate).getDate() -
                          90
                      )
                    ).getFullYear()
                  ) &&
                new Date(value) >=
                  new Date(
                    dayjs(
                      new Date(
                        new Date(props.fileReceiptState.voucherDate).setDate(
                          new Date(
                            props.fileReceiptState.voucherDate
                          ).getDate() - 90
                        )
                      )
                    ).format("MM/DD/YYYY")
                  ) &&
                new Date(value).toLocaleDateString().slice(-4) <=
                  String(
                    new Date(props.fileReceiptState.voucherDate).getFullYear()
                  ) &&
                new Date(value) <=
                  new Date(
                    dayjs(props.fileReceiptState.voucherDate).format(
                      "MM/DD/YYYY"
                    )
                  )
                  ? setChequeDateError(false)
                  : setChequeDateError(true);
              }}
            />
            {chequeDateHasError && props.screenMode === "CREATE" && (
              <p className="error">
                {new Date(props.fileReceiptState.chequeDate).toDateString() ===
                  "Invalid Date" ||
                new Date(props.fileReceiptState.chequeDate) <
                  new Date(
                    new Date(props.fileReceiptState.voucherDate).setDate(
                      new Date(props.fileReceiptState.voucherDate).getDate() -
                        90
                    )
                  ) ||
                new Date(props.fileReceiptState.chequeDate) >
                  new Date(props.fileReceiptState.voucherDate)
                  ? "Please Select Valid Cheque Date"
                  : props.fileReceiptState.chequeDate === "" ||
                    props.fileReceiptState.chequeDate === undefined ||
                    props.fileReceiptState.chequeDate === null
                  ? "Please Select Cheque Date"
                  : ""}
              </p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Bank Request Date"
              id="bankReqDate"
              variant="standard"
              maxDate={
                new Date(
                  new Date(props.fileReceiptState.voucherDate).setDate(
                    new Date(props.fileReceiptState.voucherDate).getDate() + 30
                  )
                )
              }
              onOpen={() => {
                let dateMap = {
                  chequeDateEnable: false,
                  bankDateEnable: true,
                  voucherDateEnable: false,
                  bankingDateEnable: false,
                  realizationDateEnable: false,
                };
                dispatch(
                  FileReceiptGridReducerAction.updateDateEnableDetails(dateMap)
                );
              }}
              minDate={props.fileReceiptState.voucherDate}
              value={props.fileReceiptState.bankReqDate}
              type="text"
              placeholder="Select Bank Request Date"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.bankReqDate,
                  value: event,
                });
                const value = event;
                new Date(value).toDateString() !== "Invalid Date" &&
                value !== null &&
                new Date(value).toLocaleDateString().slice(-4) >=
                  String(
                    new Date(props.fileReceiptState.voucherDate).getFullYear()
                  ) &&
                new Date(value) >=
                  new Date(
                    dayjs(props.fileReceiptState.voucherDate).format(
                      "MM/DD/YYYY"
                    )
                  ) &&
                new Date(value).toLocaleDateString().slice(-4) <=
                  String(
                    new Date(
                      new Date(props.fileReceiptState.voucherDate).setDate(
                        new Date(props.fileReceiptState.voucherDate).getDate() +
                          30
                      )
                    ).getFullYear()
                  ) &&
                new Date(value) <=
                  new Date(
                    dayjs(
                      new Date(
                        new Date(props.fileReceiptState.voucherDate).setDate(
                          new Date(
                            props.fileReceiptState.voucherDate
                          ).getDate() + 30
                        )
                      )
                    ).format("MM/DD/YYYY")
                  )
                  ? setBankReqDateError(false)
                  : setBankReqDateError(true);
              }}
            />
            {bankReqDateHasError && (
              <p className="error">
                {new Date(props.fileReceiptState.bankReqDate).toDateString() ===
                  "Invalid Date" ||
                new Date(props.fileReceiptState.bankReqDate) <
                  new Date(props.fileReceiptState.voucherDate) ||
                new Date(props.fileReceiptState.bankReqDate) >
                  new Date(
                    new Date(
                      new Date(props.fileReceiptState.voucherDate).setDate(
                        new Date(props.fileReceiptState.voucherDate).getDate() +
                          30
                      )
                    )
                  )
                  ? "Please Select Valid Bank Request Date"
                  : props.fileReceiptState.bankReqDate === "" ||
                    props.fileReceiptState.bankReqDate === undefined ||
                    props.fileReceiptState.bankReqDate === null
                  ? "Please Select Bank Request Date"
                  : ""}
              </p>
            )}
          </Grid>

          {props.screenMode !== "CREATE" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                disabled={props.screenMode === "VIEW"}
                required={props.screenMode === "MODIFY"}
                label="Banking Date"
                id="bankingDate"
                variant="standard"
                minDate={props.fileReceiptState.bankReqDate}
                value={props.fileReceiptState.bankingDate}
                type="text"
                placeholder="Select Banking Date"
                onChange={(event) => {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.bankingDate,
                    value: event,
                  });
                  const value = event;
                  if (value !== null && value !== undefined && value !== "") {
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value).toLocaleDateString().slice(-4) >=
                      String(
                        new Date(
                          props.fileReceiptState.bankReqDate
                        ).getFullYear()
                      ) &&
                    new Date(value) >=
                      new Date(
                        dayjs(props.fileReceiptState.bankReqDate).format(
                          "MM/DD/YYYY"
                        )
                      ) &&
                    new Date(value).toLocaleDateString().slice(-4) <= "2055"
                      ? setBankingDateError(false)
                      : setBankingDateError(true);
                  } else {
                    setBankingDateError(false);
                  }
                }}
                onOpen={() => {
                  let dateMap = {
                    chequeDateEnable: false,
                    bankDateEnable: false,
                    voucherDateEnable: false,
                    bankingDateEnable: true,
                    realizationDateEnable: false,
                  };
                  dispatch(
                    FileReceiptGridReducerAction.updateDateEnableDetails(
                      dateMap
                    )
                  );
                }}
              />
              {bankingDateHasError && (
                <p className="error">
                  {new Date(
                    props.fileReceiptState.bankingDate
                  ).toDateString() === "Invalid Date" ||
                  new Date(props.fileReceiptState.bankingDate) <
                    new Date(props.fileReceiptState.bankReqDate) ||
                  new Date(props.fileReceiptState.bankingDate) >
                    new Date(new Date("12/31/2055"))
                    ? "Please Select Valid Banking Date"
                    : props.fileReceiptState.bankingDate === "" ||
                      props.fileReceiptState.bankingDate === undefined ||
                      props.fileReceiptState.bankingDate === null
                    ? "Please Select Banking Date"
                    : ""}
                </p>
              )}
            </Grid>
          )}

          {props.screenMode !== "CREATE" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                disabled={props.screenMode === "VIEW"}
                required={props.screenMode === "MODIFY"}
                label="Realization Date"
                id="realizationDate"
                variant="standard"
                minDate={props.fileReceiptState.bankReqDate}
                value={props.fileReceiptState.realizationDate}
                type="text"
                placeholder="Select Realization Date"
                onChange={(event) => {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.realizationDate,
                    value: event,
                  });
                  const value = event;
                  if (value !== null && value !== undefined && value !== "") {
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value).toLocaleDateString().slice(-4) >=
                      String(
                        new Date(
                          props.fileReceiptState.bankReqDate
                        ).getFullYear()
                      ) &&
                    new Date(value) >=
                      new Date(
                        dayjs(props.fileReceiptState.bankReqDate).format(
                          "MM/DD/YYYY"
                        )
                      ) &&
                    new Date(value).toLocaleDateString().slice(-4) <= "2055"
                      ? setRealizationDateError(false)
                      : setRealizationDateError(true);
                  } else {
                    setRealizationDateError(false);
                  }
                }}
                onOpen={() => {
                  let dateMap = {
                    chequeDateEnable: false,
                    bankDateEnable: false,
                    voucherDateEnable: false,
                    bankingDateEnable: false,
                    realizationDateEnable: true,
                  };
                  dispatch(
                    FileReceiptGridReducerAction.updateDateEnableDetails(
                      dateMap
                    )
                  );
                }}
              />
              {realizationDateHasError && (
                <p className="error">
                  {new Date(
                    props.fileReceiptState.realizationDate
                  ).toDateString() === "Invalid Date" ||
                  new Date(props.fileReceiptState.realizationDate) <
                    new Date(props.fileReceiptState.bankReqDate) ||
                  new Date(props.fileReceiptState.realizationDate) >
                    new Date(new Date("12/31/2055"))
                    ? "Please Select Valid Realization Date"
                    : props.fileReceiptState.realizationDate === "" ||
                      props.fileReceiptState.realizationDate === undefined ||
                      props.fileReceiptState.realizationDate === null
                    ? "Please Select Realization Date"
                    : ""}
                </p>
              )}
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Drawee Bank"
              id="draweeBank"
              variant="standard"
              autoCompleteValues={draweerBanksArray}
              value={props.fileReceiptState.drawerBank}
              type="text"
              placeholder="Select Drawee Bank"
              onChange={(event, value) => {
                onChangeDraweerBank(value);
                setDraweerBankError(value && value !== "" ? false : true);
              }}
            />
            {draweerBankHasError && (
              <p className="error">Please Select Drawee Bank</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={props.screenMode !== "CREATE"}
              required={props.screenMode === "CREATE"}
              label="Drawee Bank Branch"
              id="draweeBranch"
              variant="standard"
              autoCompleteValues={draweerBanksBranchArray}
              value={props.fileReceiptState.drawerBranch}
              type="text"
              placeholder="Select Drawee Bank Branch"
              onChange={(event, value) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.drawerBranch,
                  value: value,
                });
                setDraweerBranchError(value && value !== "" ? false : true);
              }}
            />
            {draweerBranchHasError && (
              <p className="error">Please Select Drawee Bank Branch</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <InputLabel
              id="narration"
              sx={{
                color: "#004A92",
                marginTop: "4px",
                fontWeight: 400,
                fontSize: "0.875rem",
              }}
              required={true}
            >
              Narration
            </InputLabel>
            <TextareaAutosize
              disabled={props.screenMode === "VIEW"}
              id="narration"
              maxRows={4}
              required={true}
              value={props.fileReceiptState.narration}
              aria-label="maximum height"
              onChange={(event, value) => {
                removeUnwantedChars(
                  event.target.value,
                  props.fileReceiptScreenFields.narration
                );
              }}
              style={{
                width: "100%",
                height: "50px",
                borderRadius: "4px",
                resize: "none",
                outline: "none",
                fontFamily: "inherit",
                fontSize: "inherit",
                overflow: "auto",
              }}
            />
            {narrationHasError && (
              <p className="error">
                {props.fileReceiptState.narration === null ||
                props.fileReceiptState.narration === undefined ||
                props.fileReceiptState.narration === "" ||
                props.fileReceiptState.narration.length === 0
                  ? "Please Enter Narration."
                  : "Please Enter Narration less than 2000 Characters."}
              </p>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  const prePayDetailsContent = (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "white",
        marginBottom: "16px",
        marginTop: "-2%",
      }}
    >
      <Box component="form">
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <CustomAutoComplete
              type="text"
              label="Prepay Reason"
              variant="standard"
              placeholder="Select Prepay Reason"
              autoCompleteValues={prePaymentReasonValues}
              value={prePayDetails.prepayReason}
              required={props.screenMode !== "VIEW"}
              disabled={props.screenMode === "VIEW"}
              onChange={(event, value) => {
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayReason(value)
                );
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayReasonTouched(true)
                );
                if (value !== "Pre-Take over") {
                  dispatch(
                    FileReceiptGridReducerAction.updateBankAndInstructions(null)
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateTakeOverReason(null)
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateBankAndInstructionsTouched(
                      false
                    )
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateTakeOverReasonTouched(
                      false
                    )
                  );
                }
              }}
            />
            {prePayDetails.prepayReasonTouched && (
              <p className="error">
                {prePayDetails.prepayReason === null ||
                prePayDetails.prepayReason === undefined ||
                prePayDetails.prepayReason === ""
                  ? "Please Select PrePay Reason."
                  : ""}
              </p>
            )}
          </Grid>
          {prePayDetails.prepayReason === "Pre-Take over" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                type="text"
                required={props.screenMode !== "VIEW"}
                disabled={props.screenMode === "VIEW"}
                label="Bank and Instructions"
                variant="standard"
                placeholder="Select Bank and Instructions"
                autoCompleteValues={["HDFC", "SBI", "ICICI"]}
                value={prePayDetails.bankAndInstructions}
                onChange={(event, value) => {
                  dispatch(
                    FileReceiptGridReducerAction.updateBankAndInstructions(
                      value
                    )
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateBankAndInstructionsTouched(
                      true
                    )
                  );
                }}
              />
              {prePayDetails.bankInstructionsTouched && (
                <p className="error">
                  {prePayDetails.bankAndInstructions === null ||
                  prePayDetails.bankAndInstructions === undefined ||
                  prePayDetails.bankAndInstructions === ""
                    ? "Please Select Bank and Instructions."
                    : ""}
                </p>
              )}
            </Grid>
          )}
          {prePayDetails.prepayReason === "Pre-Take over" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                type="text"
                required={props.screenMode !== "VIEW"}
                disabled={props.screenMode === "VIEW"}
                label="TakeOver Reason"
                variant="standard"
                placeholder="Select TakeOver Reason"
                autoCompleteValues={[
                  "Additional Loan",
                  "Property Sale",
                  "ROI",
                  "ROI & Additional Loan",
                  "Service Issue",
                ]}
                value={prePayDetails.takeOverReason}
                onChange={(event, value) => {
                  dispatch(
                    FileReceiptGridReducerAction.updateTakeOverReason(value)
                  );
                  dispatch(
                    FileReceiptGridReducerAction.updateTakeOverReasonTouched(
                      true
                    )
                  );
                }}
              />
              {prePayDetails.takeOverReasonTouched && (
                <p className="error">
                  {prePayDetails.takeOverReason === null ||
                  prePayDetails.takeOverReason === undefined ||
                  prePayDetails.takeOverReason === ""
                    ? "Please Select Take Over Reason."
                    : ""}
                </p>
              )}
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <CustomDateField
              label="Effective Date"
              variant="standard"
              required={false}
              disabled={true}
              // required={props.screenMode !== "VIEW"}
              // disabled={props.screenMode === "VIEW"}
              value={prePayDetails.effectiveDate}
              // minDate={new Date()}
              // maxDate={new Date()}
              onChange={(newValue) => {
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayEffectiveDate(
                    new Date(dayjs(newValue).format("MM/DD/YYYY"))
                  )
                );
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayEffectiveDateTouch(
                    newValue ? false : true
                  )
                );
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayEffectiveDateIsValid(
                    newValue !== undefined &&
                      newValue !== "" &&
                      newValue !== null
                  )
                );
                dispatch(
                  FileReceiptGridReducerAction.updatePrepayEffectiveDateHasError(
                    (newValue ? false : true) &&
                      !(
                        newValue !== undefined &&
                        newValue !== "" &&
                        newValue !== null
                      )
                  )
                );
                if (
                  newValue !== null &&
                  newValue !== undefined &&
                  newValue !== ""
                ) {
                  new Date(newValue).toDateString() !== "Invalid Date" &&
                  new Date(newValue).toLocaleDateString().slice(-4) >=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) >=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
                  new Date(newValue).toLocaleDateString().slice(-4) <=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) <=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY"))
                    ? dispatch(
                        FileReceiptGridReducerAction.updatePrepayEffectiveDateValidDateError(
                          false
                        )
                      )
                    : dispatch(
                        FileReceiptGridReducerAction.updatePrepayEffectiveDateValidDateError(
                          true
                        )
                      );
                } else {
                  dispatch(
                    FileReceiptGridReducerAction.updatePrepayEffectiveDateValidDateError(
                      false
                    )
                  );
                }
              }}
            />
            {/* {(prePayDetails.prepayEffectiveDateHasError ||
              prePayDetails.prepayEffectiveDateValidDateError) && (
              <p className="error">Please Enter Valid Date</p>
            )} */}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <InputLabel
              id="narration"
              sx={{
                color: "#004A92",
                marginTop: "4px",
                fontWeight: 400,
                fontSize: "0.875rem",
              }}
              required={true}
            >
              Narration
            </InputLabel>
            <TextareaAutosize
              id="narration"
              maxRows={4}
              required={props.screenMode !== "VIEW"}
              disabled={props.screenMode === "VIEW"}
              value={prePayDetails.prepayNarration}
              aria-label="maximum height"
              onChange={(event, value) => {
                removeUnwantedChars(event.target.value, "prepayNarration");
              }}
              style={{
                width: "100%",
                height: "50px",
                borderRadius: "4px",
                resize: "none",
                outline: "none",
                fontFamily: "inherit",
                fontSize: "inherit",
                overflow: "auto",
              }}
            />
            {prePayDetails.prepayNarrationTouched && (
              <p className="error">
                {prePayDetails.prepayNarration === null ||
                prePayDetails.prepayNarration === undefined ||
                prePayDetails.prepayNarration === "" ||
                prePayDetails.prepayNarration.length === 0
                  ? "Please Enter Narration."
                  : prePayDetails.prepayNarration.length > 2000
                  ? "Please Enter Narration less than 2000 Characters."
                  : ""}
              </p>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ width: "100%", marginTop: "1rem", backgroundColor: "white" }}>
      <TabContext
        value={props.tabValue}
        sx={{
          height: window.innerHeight > 650 ? window.innerHeight / 1.7 : "260px",
        }}
      >
        <Box
          sx={{
            borderColor: "divider",
            backgroundColor: "#eeeeee",
            marginLeft: "2%",
            display: "flex",
          }}
        >
          <TabList
            onChange={(event, newpage) => props.handleTabChange(newpage)}
            aria-label="File Receipt Tabs"
            TabIndicatorProps={{ hidden: true }}
            sx={{
              "& button.Mui-selected": {
                backgroundColor: "#004a92",
                color: "white",
                borderTopLeftRadius: "1rem",
                borderTopRightRadius: "1rem",
                borderBottom: "none",
                minHeight: "1rem",
                height: "2rem",
              },
              "& div.MuiTabs-flexContainer": {
                flexWrap: "wrap",
              },
              "& button": {
                outline: "none",
                marginRight: "0.2rem",
                background: "#fafafa",
                color: "#7f7f7f",
                transition: "all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1)",
                borderBottom: "2px solid #AAAAAA",
                textTransform: "none",
                borderTopLeftRadius: "1rem",
                borderTopRightRadius: "1rem",
                backgroundColor: "#D7D7D7",
                minHeight: "1rem",
                height: "2rem",
              },
            }}
          >
            <Tab label="Receipt Details" value="1" />
            <Tab label="Credit Amount Details" value="2" disabled={true} />
          </TabList>
        </Box>

        <TabPanel value="1">
          {
            <React.Fragment>
              {
                <AccordianContainer
                  id="accord"
                  title="Receipt Info"
                  initialOpen={true}
                  sx={{ margin: "8px !important" }}
                >
                  {receiptDetailsContent}
                </AccordianContainer>
              }
              {
                <AccordianContainer
                  id="accord"
                  title="Cheque Details"
                  initialOpen={true}
                  sx={{ margin: "8px !important" }}
                >
                  {chequeDetailsContent}
                </AccordianContainer>
              }
              {prepayReceiptMode && (
                <AccordianContainer
                  id="accord"
                  title="PrePay Details"
                  initialOpen={true}
                  sx={{ margin: "8px !important" }}
                >
                  {prePayDetailsContent}
                </AccordianContainer>
              )}
              <Box
                sx={{
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Ctrl+G" placement="top">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{ height: "2rem" }}
                    disabled={voucherDateValidDateError}
                    onClick={() => {
                      onProceedClick();
                    }}
                    ref={nextRef}
                  >
                    Next
                  </Button>
                </Tooltip>
              </Box>
              <Dialog
                open={open}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle>{dialogTitleMessage}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description">
                    {dialogMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Tooltip title="Ctrl+Q" placement="top">
                    <Button onClick={handleClose} ref={cancelRef}>
                      Cancel
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ctrl+Y" placement="top">
                    <Button onClick={handleOk} ref={yesRef}>
                      Yes
                    </Button>
                  </Tooltip>
                </DialogActions>
              </Dialog>
            </React.Fragment>
          }
        </TabPanel>
        <TabPanel value="2">
          <CreditAmountDetails
            fileReceiptState={props.fileReceiptState}
            dispatch={props.dispatch}
            fileReceiptScreenFields={props.fileReceiptScreenFields}
            glAccountDataMap={glAccountDataMap}
            screenMode={props.screenMode}
            appNumByCustIdBranch={props.appNumByCustIdBranch}
            handleTabChange={handleTabChange}
            branchNamesWithCodes={props.branchNamesWithCodes}
            cashHandlingGlAccCode={props.cashHandlingGlAccCode}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default ChequeReceiptDetails;
